import script from "./PostCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostCover.vue?vue&type=script&setup=true&lang=ts"

import "./PostCover.vue?vue&type=style&index=0&id=de7e7f1a&scoped=true&lang=css"

import exportComponent from "/home/windows/Documents/workspace/proxyscrape-project/proxyscrape-website-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de7e7f1a"]])

export default __exports__